import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
	AudienceActions,
	AudienceTable,
	useAudience,
} from "@di-devs/audience-feature-plugin/client";
import type { AudienceWithStatus } from "@di-devs/audience-feature-plugin/shared";
import { type TableColumnsType, Modal, message } from "antd";
import { type FC, useCallback } from "react";
import { useBetterFeatureClient } from "@di-devs/utils-fe";
import type { FeatureClient } from "@/config/client";
import { useListMemberAttributes } from "@/queries/memberAttributes.queries";
import { getEventColumns } from "./columns";

import { useEventAdminManager } from "@di-devs/event-feature-plugin/client";

const EventAudienceTab: FC = () => {
	const client = useBetterFeatureClient<FeatureClient>();
	const [modal, contextHolder] = Modal.useModal();

	const { events } = useEventAdminManager();

	const {
		hooks: { audiencesQuery, deleteAudienceMutation },
	} = useAudience({
		type: "event",
	});

	// Fetch member attributes for the table columns
	const { data: memberAttributesResponse } = useListMemberAttributes(client);
	const memberAttributes = (memberAttributesResponse as any)?.data?.data || [];

	const handleDelete = useCallback(
		(record: AudienceWithStatus) => {
			modal.confirm({
				title: "確認",
				icon: <ExclamationCircleOutlined className="text-red-600" />,
				content: (
					<div>
						<p className="mb-2">
							以下のオーディエンスを削除してもよろしいですか？
						</p>
						<p className="text-red-600 font-semibold">
							{record.description || "ー"}
						</p>
					</div>
				),
				okText: "削除",
				okButtonProps: { type: "primary", danger: true },
				cancelText: "キャンセル",
				centered: true,
				async onOk() {
					try {
						await deleteAudienceMutation.mutateAsync(record.audienceGroupId);
						message.success("オーディエンスを削除しました");
					} catch (error) {
						message.error("削除に失敗しました");
					}
				},
			});
		},
		[modal, deleteAudienceMutation],
	);

	const columns: TableColumnsType<AudienceWithStatus> = getEventColumns({
		memberAttributes,
		onDelete: handleDelete,
		events,
	});

	return (
		<div className="event-audience-container">
			<AudienceActions />

			<AudienceTable<AudienceWithStatus>
				data={audiencesQuery.data?.data || []}
				columns={columns}
				rowKey="audienceGroupId"
				emptyText="イベントオーディエンスのデータがありません"
				pagination={{
					showSizeChanger: false,
				}}
			/>

			{contextHolder}
		</div>
	);
};

export default EventAudienceTab;
